import { ReasonCodesInitialState } from './types';
import { ActionTypesReasonCodes } from './constants';

const reasonCodesInitialState: ReasonCodesInitialState = {
  reasonCodesData: [],
  showReasonCodesGrid: false,
  isReasonCodesGridLoading: false,
  disabledColumns: [],
};

const reasonCodesReducer = (state = reasonCodesInitialState, action) => {
  switch (action.type) {
    case ActionTypesReasonCodes.SET_REASON_CODES_DATA:
      return {
        ...state,
        reasonCodesData: action.reasonCodesData,
      };
    case ActionTypesReasonCodes.SHOW_REASON_CODES_GRID:
      return {
        ...state,
        showReasonCodesGrid: action.showReasonCodesGrid,
      };
    case ActionTypesReasonCodes.SET_LOADING_INDICATOR:
      return {
        ...state,
        isReasonCodesGridLoading: action.isReasonCodesGridLoading,
      };
    case ActionTypesReasonCodes.RESET_REASON_CODES:
      return {
        ...state,
        reasonCodesData: [],
        showReasonCodesGrid: false,
      };
    case ActionTypesReasonCodes.SET_DISABLED_COLUMNS:
      return {
        ...state,
        disabledColumns: action.disabledColumns,
      };
    default:
      return state;
  }
};

export default reasonCodesReducer;
